import Footer from '../components/footer';
import Sylviane from "../assets/img/Sylviane.jpg"
import { ScrollRestoration } from "react-router-dom"

export default function Contact() {
   

    return (
        <>   
           <section id="homescreen" className="w-full py-36  bg-expertes bg-cover lg:bg-right bg-left">
                <div className='container m-auto grid sm:grid-cols-2 gap-4 h-full text-white z-10 pt-20 flex items-center justify-center'>
                    <div className='2xl:px-32 xl:px-24 lg:px-16 px-8'>
                        <h1 className='text-white 2xl:text-7xl xl:text-5xl lg:text-4xl text-3xl font-extrabold'>
                           Nos expertes
                        </h1>                        
                    </div>                    
                </div>
           </section>

           <section id="gray" className="overflow-hidden bg-grays py-12">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <div className="col-span-1 md:-ml-4 lg:-ml-0">           
                            <div className="lg:max-w-3xl">                                
                                <p className="m-auto pt-6 text-lg">
                                    Expertise & Benefits a également un réseau d'experts qui travaillent en collaboration avec la Société d'une manière régulière.
                                </p>
                            </div>
                        </div>                    
                    </div>
                </div>
           </section>

           
           <section id="white" className="overflow-hidden bg-gray py-12">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <div className="col-span-1 md:-ml-4 lg:-ml-0 flex">
                            <img src={Sylviane} className='w-1/2 rounded-xl m-auto' alt="Sylviane" />
                        </div>
                        <div className="col-span-1 md:-ml-4 lg:-ml-0">
                            <h3 className="text-lg font-semibold leading-6 text-gray-900"> Sylviane Aguirre - <i>Présidente</i></h3>  
                            <p className='text-lg leading-6 text-gray-600 py-6'>
                                Après une expérience de 35 ans au sein du Groupe Schlumberger comme Responsable Ressources Humaines, gestion Mobilité Internationale, puis comme Pensions & Benefits Manager, elle crée ensuite son propre cabinet de conseil en retraite pour accompagner les entreprises, les salariés, les cadres dirigeants.
                                Actuellement elle intervient d'une manière indépendante, au sein de son Cabinet Expertise & Benefits.
                            </p>
                            <p className='text-lg leading-6 text-gray-600 py-6'>
                                Elle est intervenue comme formatrice dans le Mastère Compensation & Benefits et Mobilité Internationale au Cercle Magellan. Elle participe également au groupe de travail de Recherche, Chaire Transitions Démographiques, Transitions Economiques, Université Paris Dauphine « travaux relatifs à la réforme des retraites ». Elle a fait partie du groupe de travail la Fabrique d'Assurance livre blanc
                            </p>
                        </div>                                          
                    </div>                    
                </div>
           </section>

            <Footer />

            <ScrollRestoration />
        </>
    )
}